import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Row, Col, Badge } from 'react-bootstrap';

import { setStatusColor, formatStatusText } from 'Helpers/UiHelper';

const StatusStaffTabsRow = (props) => {
  const { flyToWorkTicketInfo } = props;

  return (
    <React.Fragment>
      <Row style={{ paddingTop: '0.5%' }}>
        <Col lg={8} style={{ paddingBottom: '0.5%' }}>
          Status :{' '}
          <Badge bg={setStatusColor(flyToWorkTicketInfo.status)}> {formatStatusText(flyToWorkTicketInfo.status)}</Badge>{' '}
          <Badge bg={setStatusColor(flyToWorkTicketInfo.confirmedStatus)}>
            {formatStatusText(flyToWorkTicketInfo.confirmedStatus)}
          </Badge>
          <br></br>
          Direction :{' '}
          <Badge bg={setStatusColor(flyToWorkTicketInfo.direction)}>
            {formatStatusText(flyToWorkTicketInfo.direction)}
          </Badge>
          <br></br>
          Type of flight :{' '}
          <Badge bg={setStatusColor(flyToWorkTicketInfo.typeOfFlight)}>
            {formatStatusText(flyToWorkTicketInfo.typeOfFlight)}
          </Badge>
        </Col>
        <Col lg={4} className="justify-content-end">
          <Breadcrumb style={{ display: 'flex', flexDirection: 'row-reverse' }}>
            <Breadcrumb.Item href="/">F2w</Breadcrumb.Item>
            <Breadcrumb.Item href="/staff">Ticket</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {flyToWorkTicketInfo.lastName}, {flyToWorkTicketInfo.firstName}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
    </React.Fragment>
  );
};

StatusStaffTabsRow.propTypes = {
  flyToWorkTicketInfo: PropTypes.shape({
    status: PropTypes.string,
    confirmedStatus: PropTypes.string,
    direction: PropTypes.string,
    typeOfFlight: PropTypes.string,
    lastName: PropTypes.string,
    firstName: PropTypes.string,
  }).isRequired,
};

export default StatusStaffTabsRow;
